import { render, staticRenderFns } from "./EditProfile.vue?vue&type=template&id=2285c017&scoped=true"
import script from "./EditProfile.vue?vue&type=script&lang=ts"
export * from "./EditProfile.vue?vue&type=script&lang=ts"
import style0 from "./EditProfile.vue?vue&type=style&index=0&id=2285c017&prod&lang=scss&scoped=true"
import style1 from "./EditProfile.vue?vue&type=style&index=1&id=2285c017&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2285c017",
  null
  
)

export default component.exports